import Footer from "components/footer/FooterAuthDefault";
import wasaaStacked from "assets/wasaa/wasaa-logo-stacked.svg";
import wasaaStackedDark from "assets/wasaa/wasaa-logo-stacked-on-dark.svg";
import { Routes, Route, Navigate } from "react-router-dom";
import routes from "routes.js";
import FixedPlugin from "components/fixedPlugin/FixedPlugin";

export default function Auth() {
  const getRoutes = (routes) => {
    return routes.map((prop, key) => {
      if (prop.layout === "/auth") {
        return (
          <Route path={`/${prop.path}`} element={prop.component} key={key} />
        );
      } else {
        return null;
      }
    });
  };
  document.documentElement.dir = "ltr";
  return (
    <div className="relative min-h-screen w-full bg-muted/60 text-foreground dark:bg-background">
      <FixedPlugin />
      <main className="mx-auto flex min-h-screen w-full max-w-[460px] flex-col px-4 pb-6 pt-6 sm:pt-10">
        <div className="flex flex-1 flex-col justify-center py-8">
          {/* Stacked Wasaa logo + portal label (Kuest auth: logo above a single card) */}
          <div className="mb-6 flex flex-col items-center gap-3 text-center">
            <img src={wasaaStacked} alt="Wasaa Markets" className="h-20 w-auto dark:hidden" />
            <img src={wasaaStackedDark} alt="Wasaa Markets" className="hidden h-20 w-auto dark:block" />
            <p className="text-sm font-medium text-muted-foreground">Tenant and Partner Portal</p>
          </div>
          <div className="w-full rounded-xl border border-border bg-card p-6 text-card-foreground shadow-card sm:p-8">
            <Routes>
              {getRoutes(routes)}
              <Route
                path="/"
                element={<Navigate to="/auth/sign-in" replace />}
              />
            </Routes>
          </div>
        </div>
        <Footer />
      </main>
    </div>
  );
}
